export default __webpack_public_path__ + "static/media/RewardsText.8e128522.svg";